import React from 'react';
import glamorous from 'glamorous';
import { Card } from 'react-toolbox/lib/card';
import Accordion from '../../Accordion';
import {
  AccordionHeader,
  AccordionContent as Content,
} from '../../Accordion/DefaultComponents';
import Question from './Question';
import styles from './styles.css'

export const orderSort = (a, b) => a.order - b.order;

const Header = glamorous(AccordionHeader)(
  {
    fontWeight: 'normal',
    padding: '1rem',
    transition: 'background-color .6s, color .4s',
  },
  ({ collapsed, color }) => {
    return (
      !collapsed && {
        backgroundColor: color,
        color: '#fff',
      }
    );
  }
);

const AccordionText = glamorous.div({
  backgroundColor: '#fafafa',
  padding: '1.4rem 1.6rem',
  borderTop: '1px solid #dedede',
  overflowY: 'auto',
  lineHeight: '1.8rem',
  fontSize: '1.6rem',
});

const QuestionGroup = props => {
  return (
    <div>
      <Card className={styles.card}>
        <h4>
          {props.description}
        </h4>
        {props.questions.sort(orderSort).map(question => {
          const id = question.key;
          return (
            <Question
              key={id}
              value={props.responses[id]}
              error={props.errors[id]}
              onChange={props.onChange(id)}
              onBlur={props.onBlur(id)}
              color={props.color}
              {...question}
            />
          );
        })}
      </Card>
      <div>
        {['Background', 'Proponents', 'Opponents'].map(title => {
          const content = props[title.toLowerCase()];
          return content
            ? <Card key={title} style={{ marginTop: '8px', boxShadow: 'none' }}>
                <Accordion>
                  <Header title={title} color={'#333333'} />
                  <Content>
                    <AccordionText children={content} />
                  </Content>
                </Accordion>
              </Card>
            : null;
        })}
      </div>
    </div>
  );
};

export default QuestionGroup;



// WEBPACK FOOTER //
// ./src/App/account/components/Surveys/QuestionGroup/index.js